module.exports = __webpack_public_path__ + "static/media/14UNEP28.b9748be8.jpg";